import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataEntity } from '../../../../models/data-entities';
import { Workflow } from 'src/app/models';
import { Activity, ActivityModel } from 'src/app/models/activities';

@Component({
    selector: 'wm-data-entity-editor-base',
    templateUrl: './data-entity-editor-base.component.html',
    styleUrls: ['./data-entity-editor-base.component.css'],
    standalone: false
})
export class DataEntityEditorBaseComponent implements OnInit {
  constructor() {}

  @Input() form: UntypedFormGroup;

  @Input() dataEntity: DataEntity;

  @Output() dataEntityChange: EventEmitter<DataEntity> = new EventEmitter<
    DataEntity
  >();
  @Input() workflow: Workflow;
  @Input() activity: Activity<ActivityModel>;
  @Input() workflowVersionId: string;
  /**
   * There are some scenarios in which this editor needs to target a different jurisdiction for resources than the client that is on the context
   */
  @Input() targetClientId: string; 
  /**
   * We need to know the difference between no targetClient passed, and Template Library being the target (null targetClientId)
   */
  @Input() globalTarget = false;
  
  @Output() closeRequested: EventEmitter<any> = new EventEmitter<any>();
  /**
   * Trigger a preview rebuild from within the editor component.
   */
  @Output() buildPreview: EventEmitter<any> = new EventEmitter<any>();
  @Output() updated: EventEmitter<DataEntity> = new EventEmitter<DataEntity>();

  ngOnInit() {}
}
